import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('DropdownWrapper')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    '& > *:not(only-child)': {
      mr: ['zero', 'zero', 'm'],
    },
  }),
);

themeStyles.addBaseStyles('SelectorWrapper')(
  css({
    width: ['280px', '280px', '218px'],
    mb: ['l', 'l', 'zero'],
    textAlign: 'left',
  }),
);

themeStyles.addBaseStyles('StyledDropdown')(
  css({
    lineHeight: '24px',
    '>div': {
      // Add ellipsis to selected value
      '>span': {
        textOverflow: 'ellipsis',
        wordBreak: 'break-word',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    },
  }),
);

export default themeStyles;
